import { render, staticRenderFns } from "./FormTemplateForm.vue?vue&type=template&id=6e28f626&"
import script from "./FormTemplateForm.vue?vue&type=script&lang=js&"
export * from "./FormTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports